import React from 'react'
import PropTypes from 'prop-types'

import Avatars from './Avatars'

const AvatarsWithLable = (props) => {
  const { id, name, src, characters, children, className } = props
  return (
    <div className={className}>
      <div className="avatar-lable-container flex space-x-3">
        <Avatars
          id={id}
          name={name}
          src={src}
          characters={characters}
          className={className}
        />
        {children}
      </div>
    </div>
  )
}

export default AvatarsWithLable

AvatarsWithLable.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  characters: PropTypes.string.isRequired,
}
